import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/provide/auth.service';
import { CommonService } from 'src/app/provide/common.service';
declare var $;
@Component({
    selector: 'app-customer-service-add-quantity',
    templateUrl: './customer-service-add-quantity.component.html',
    styleUrls: ['./customer-service-add-quantity.component.scss'],
    standalone: false
})
export class CustomerServiceAddQuantityComponent implements OnInit {
  _id: any;
  isLoggedIn: any;
  loggedInUserType: any;
  catID: any;
  UsID: any;
  flag: boolean = true;
  headingName: any = 'BOOKING PROVIDERS';
  linkerRouteItems: any = [
    { name: 'Home', route: '/home' },
    { name: 'Bookings', route: '/customer-service-list' },
    { name: 'Booking Detail', route: '/customer-service-available' },
  ];
  categoryName: any;
  panelOpenState = false; //accordian open close question's and answer's
  selectedService: any = [];
  addressId: any;
  step = 0;
  todayDate = new Date().toISOString().split('T')[0];
  spordicType: string;
  timeArray = [];
  valueQuantityAvailabe = 1;
  intrestedPrice: boolean = false;
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }
  getcurrentdatetime(e) {
    let currentDate = new Date().toISOString().split('T')[0];
    let currentTime = new Date().getHours();
    let i = 1;
    this.timeArray = [];
    if (currentDate == new Date(e.target.value).toISOString().split('T')[0]) {
      for (let it = currentTime; it < 20; it++) {
        let pmAm = currentTime > 12 ? 'PM' : 'AM';

        if (currentTime < 12) {
          let t = `${currentTime}:00${pmAm} - ${currentTime + 1}:00${
            currentTime + 1 == 12 ? 'PM' : pmAm
          } `;
          this.timeArray.push(t);
        }
        if (currentTime > 12) {
          let t = `${currentTime - 11}:00${pmAm} - ${
            currentTime - 10
          }:00${pmAm} `;
          this.timeArray.push(t);
        }
        currentTime++;
        i++;
      }
    } else {
      let c = 8;
      for (let it = c; it < 21; it++) {
        let pmAm = c > 12 ? 'PM' : 'AM';
        if (c < 12) {
          let t = `${c}:00${pmAm} - ${c + 1}:00${c + 1 == 12 ? 'PM' : pmAm} `;
          this.timeArray.push(t);
        }
        if (c > 12) {
          let t = `${c - 12}:00${pmAm} - ${c - 11}:00${pmAm} `;
          this.timeArray.push(t);
        }
        c++;
        i++;
      }
    }
  }
  prevStep() {
    this.step--;
  }

  serviceDetails = [];
  constructor(
    private activatedroute: ActivatedRoute,
    private toastrService: ToastrService,
    public commonService: CommonService,
    private router: Router,
    public authService: AuthService,
    private datePipe: DatePipe,
    private sanatizer: DomSanitizer
  ) {
    this.activatedroute.queryParams.subscribe((res: any) => {
      this.catID = res.categoryId;
      this.UsID = res.userId;
      this.categoryName = res.categoryName;
    });
    this.spordicType = localStorage.getItem('campainPrefrences');
    this.selectedService = JSON.parse(
      sessionStorage.getItem('selectedService')
    );
    console.log(this.selectedService, 'ssssssssssssssssservice');

    this.addressId = localStorage.getItem('primaryAddressId');

    for (let item of this.selectedService) {
      for (let items of item.serviceArray) {
        items['quantity'] = 1;
      }
    }
    for (let item of this.selectedService) {
      for (let i = 0; i < item.serviceArray.length; i++) {
        if (item.serviceArray[i].isIntrestPriceAdded == false) {
          this.intrestedPrice = true;
        }
      }
    }
    console.log(this.selectedService);
    this.serviceDetails;
  }

  ngOnInit(): void {
    this.authService.isLoggedIn.subscribe((res: any) => {
      this.isLoggedIn = res;
    });
    this.isLoggedIn = this.authService.isLogin();
    this.myWallet();
    this.authService.loggedInUserType.subscribe((res: any) => {
      this.loggedInUserType = res;
    });
    // Data Picker Initialization
    // this.getProduct();
    console.log(this.addressId);

    this.viewCategoryAvailableService();
    if (this.addressId) {
      this.viewaddress();
    }
    this.listAddress();
  }

  userId: any;
  productDetails: any;
  productId: any;
  retailerId: any;
  imgurl: any;
  imageLinks: any;

  getProduct() {
    if (this.isLoggedIn) {
      this.viewRetailerProductd();
    } else {
      this.viewRetailerProductdWithoutLogin();
    }
  }
  firstPriceSize: any = [];
  productDetailsSize: any = [];
  // get retailer detail by id
  viewRetailerProductd() {
    let apiReqUrl: any = `product/viewProduct?productId=${this._id}`;
    // let apiReqUrl: any = `${ApiEndPoint.productView + '?productId=' + this.productId}`
    this.commonService.showSpinner();
    let a = this.commonService.isLoggedIn() ? 1 : 0;
    this.commonService.postApi(apiReqUrl, {}, a).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.productDetails = res.result;
        this.productDetailsSize = res.result.priceSizeDetails;

        this.firstPriceSize = res.result.priceSizeDetails[0];
        this.price(
          this.firstPriceSize.price,
          this.firstPriceSize.quantity,
          this.firstPriceSize.value,
          this.firstPriceSize.id,
          this.firstPriceSize.unit
        );
        this.imgurl = res.result.productImage[0];
        this.imageLinks = res['result']['thumbnail'];
        this.commonService.hideSpinner();
        // this.router.navigate(['/edit-product'])
        // this.commonService.successToast(res.responseMessage);
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }
  viewRetailerProductdWithoutLogin() {
    let apiReqUrl: any = `product/viewProduct?productId=${this._id}`;
    // let apiReqUrl: any = `${ApiEndPoint.productView + '?productId=' + this.productId}`
    this.commonService.showSpinner();
    let a = this.commonService.isLoggedIn() ? 1 : 0;
    this.commonService.postApi(apiReqUrl, {}, a).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.productDetails = res.result;
        this.imgurl = res.result.productImage[0];
        this.imageLinks = res['result']['thumbnail'];
        this.commonService.hideSpinner();
        // this.router.navigate(['/edit-product'])
        // this.commonService.successToast(res.responseMessage);
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }

  forID(_id: any) {
    this.router.navigate(['/edit-product'], { queryParams: { _id: _id } });
  }

  dropDownData = [
    {
      name: 'Proceed to Checkout',
      value: '',
    },
    {
      name: 'OZOW Payment',
      value: 'OZOW',
    },
    {
      name: 'PayGate Payment',
      value: 'PAYGATE',
    },
    {
      name: 'Yoco Payment',
      value: 'YOCO',
    },
    {
      name: `Wallet`,
      value: 'WALLET',
    },
  ];
  walletPayment() {
    if (this.totalPayAmount > this.myWalletBalance) {
      this.flag = true;
      return this.commonService.errorToast('Insufficient fund in your wallet.');
    }
    let url = `order/checkOutWalletOrder?orderId=${this.buyOrderData._id}`;
    let data = {
      webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
      webError: this.commonService.webSiteUrl + 'customer-payment-error',
      webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
      cancelUrl: this.commonService.ozhoBaseUrl,
      errorUrl: this.commonService.ozhoBaseUrl,
      SuccessUrl: this.commonService.ozhoBaseUrl,
      testMode: true,
      trxFrom: 'WEB',
    };
    this.commonService.showSpinner();
    this.commonService.postApi(url, data, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.OzhoUrl = res.result;
          this.router.navigate(['/customer-payment-success']);
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        // this.commonService.errorToast("Server error")
      }
    );
  }
  myWalletBalance: any = 0;
  myWallet() {
    let url = `deliveryOrders/getWalletTransaction?isCommission=true&page=1&limit=1`;

    this.commonService.showSpinner();
    this.commonService.getApi(url, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          const walletBalance = parseFloat(
            res.result.wallet.walletAmount
          ).toFixed(2);
          this.commonService.hideSpinner();
          this.dropDownData = [
            {
              name: 'Proceed to book',
              value: '',
            },
            {
              name: 'OZOW Payment',
              value: 'OZOW',
            },
            {
              name: 'PayGate Payment',
              value: 'PAYGATE',
            },
            {
              name: 'Yoco Payment',
              value: 'YOCO',
            },
            {
              name: `Wallet (R ${walletBalance})`,
              value: 'WALLET',
            },
          ];

          this.myWalletBalance = res.result.wallet.walletAmount;
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        // this.commonService.errorToast("Server error")
      }
    );
  }
  buyOrder(flag: Number) {
    let url = `v2/service/buyService`;
    let serviceDetailArray = [];
    for (const item of this.selectedService) {
      let price = 0;
      if (item.subCategory.categoryEnum == 'DEFAULT') {
        price = parseFloat(item.serviceArray[0].isDealActive
          ? item.serviceArray[0].dealPrice
          : item.serviceArray[0].price);
      }
      
      // Skip invalid prices
      if (isNaN(price)) {
        console.warn('Invalid price detected:', item.serviceArray[0].price);
        price = 0;
      }
      
      let obj = {
        serviceId: item.serviceArray[0]._id,
        quantity: item.serviceArray[0].quantity,
        price: price,
      };
      serviceDetailArray.push(obj);
    }
    
    // Use the actual calculated values but ensure they're positive using Math.abs()
    const orderPrice = Math.abs(this.totalPayAmount);
    const actualPrice = Math.abs(this.priceValueOfService);
    const taxPrice = Math.abs(this.sumToatal);
    
    // Log the payment values for debugging
    console.log('Payment values (fixed - absolute values):', {
      orderPrice,
      actualPrice,
      taxPrice,
      originalTotalPayAmount: this.totalPayAmount
    });
    
    let apiReqData = {
      serviceDetails: serviceDetailArray,
      orderPrice: orderPrice,
      actualPrice: actualPrice,
      taxPrice: taxPrice,
      duration: this.duration,
      slots: this.timeSlots,
      address: this.addressId,
    };

    this.flag = false;
    this.commonService.postApi(url, apiReqData, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.buyOrderData = res['result'];

          if (flag == 1) {
            this.ozhoPayment();
          } else if (flag == 2) {
            this.walletPayment();
          } else if (flag == 4) {
            // Direct Yoco payment
            this.yocoPayment();
          } else {
            this.paygatePayment();
          }
        } else {
          this.flag = true;
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.flag = true;
        this.commonService.errorToast('Server error');
      }
    );
  }
  selectPayment(e) {
    if (!this.timeSlots || !this.duration) {
      return this.commonService.errorToast('Please select date and time slot');
    }

    this.commonService.showSpinner();
    
    if (e == 'OZOW') {
      this.buyOrder(1);
    } else if (e == 'WALLET') {
      this.buyOrder(2);
    } else if (e == 'YOCO') {
      // Store the current timestamp and order ID in localStorage to identify this specific order
      localStorage.setItem('orderTimestamp', new Date().toISOString());
      localStorage.setItem('paymentMethod', 'YOCO');
      
      // Set a flag to indicate we're about to process a Yoco payment
      // This will help the success page know to update the order status
      localStorage.setItem('from_yoco_payment', 'true');
      
      // Continue with the Yoco payment process
      this.buyOrder(4);
    } else if (e == 'PAYGATE') {
      // Store payment information for transaction history
      localStorage.setItem('paymentList', 'booking');
      localStorage.setItem('paymentMethod', 'PAYGATE');
      localStorage.setItem('orderTimestamp', new Date().toISOString());
      localStorage.setItem('from_paygate_payment', 'true');
      
      this.buyOrder(3);
    } else {
      this.buyOrder(3);
    }
  }

  htmlData: any;
  paygatePayment() {
    console.log('paygatePayment');
    let url = `payment/checkoutPayGate?orderId=${this.buyOrderData._id}`;
    let data = {
      webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
      webError: this.commonService.webSiteUrl + 'customer-payment-error',
      webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
      cancelUrl: this.commonService.ozhoBaseUrl,
      errorUrl: this.commonService.ozhoBaseUrl,
      SuccessUrl: this.commonService.ozhoBaseUrl,
      testMode: false,
      trxFrom: 'WEB',
    };
    this.commonService.postApi(url, data, true).subscribe(
      (res: any) => {
        console.log(res);

        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.htmlData = this.sanatizer.bypassSecurityTrustHtml(
            res.result.file
          );
          console.log(res, 'paygate response');

          // Auto-submit the form
          setTimeout(() => {
            this.autoSubmitInjectedForm('paygate-form');
          }, 1000);
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        console.log(err);
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }

  autoSubmitInjectedForm(formId: string) {
    const form = document.getElementById(formId);
    if (form) {
      (form as HTMLFormElement).submit();
    }
  }

  changeProductimage(url: any) {
    this.imgurl = url;
  }

  getPrice(e: any) {
    return this.commonService.getPrice(e);
  }
  mrp: any;
  quantity: any;
  value: any;
  unit: any;
  pdId: any;
  price(e: any, q: any, v: any, id, u) {
    (this.mrp = e), (this.quantity = q);
    this.value = v;
    this.unit = u;
    this.pdId = id;
  }
  imgSrc: any;
  productImage: any;
  serviceData: any = [];

  addWishlist(id) {
    let apiReqUrl = `user/addWishListProduct?productId=${id}`;
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, {}, 1).subscribe(
      (res: any) => {
        if (res.responseCode == 200) {
          this.commonService.hideSpinner();
          this.viewRetailerProductd();
          // this.router.navigate(['/edit-product'])
          this.commonService.successToast(res.responseMessage);
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage);
          if (res.responseCode == 401) {
            this.router.navigate['/login'];
          }
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        if (err.responseCode == 401) {
          this.router.navigate['/login'];
        }
      }
    );
  }
  UserDetailsData: any;
  serviceDetailsArray: any = [];
  viewCategoryAvailableService() {
    let apiReqUrl = `v2/service/listServiceNearMe`;
    let apiReqData = {
      userId: this.UsID || localStorage.getItem('userId'),
      categoryId: this.catID,
    };
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, apiReqData, 0).subscribe(
      (res: any) => {
        if (res.responseCode == 200) {
          this.commonService.hideSpinner();
          this.UserDetailsData = res.result.userDeails;
          this.serviceDetailsArray = res.result.docs;
          this.getTotalProductPrice();
          // this.commonService.successToast(res.responseMessage);
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage);
          this.getTotalProductPrice();
          if (res.responseCode == 401) {
            this.router.navigate['/login'];
          }
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.getTotalProductPrice();
        if (err.responseCode == 401) {
          this.router.navigate['/login'];
        }
      }
    );
  }
  profileData: any = [];
  viewaddress() {
    let url = `user/viewAddress?addressId=${this.addressId}`;
    this.commonService.showSpinner();
    this.commonService.getApi(url, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.profileData = res['result'];
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }
  navigateToserviceQuantity(qnty) {
    this.router.navigate(['/edit-address-customer'], {
      queryParams: {
        qnty: qnty,
        categoryId: this.catID,
        userId: this.userId,
        categoryName: this.categoryName,
      },
    });
  }
  navigateToEdit(qnty) {
    this.router.navigate(['/edit-address-customer'], {
      queryParams: {
        id: this.addressId,
        qnty: qnty,
        categoryId: this.catID,
        userId: this.userId,
        categoryName: this.categoryName,
      },
    });
  }
  subtotal: any = 0;
  total: any = 0;
  sum: any = 0;
  vatValue = 0;
  sumToatal = 0;
  totalPayAmount = 0;
  priceValueOfService: any = 0;
  getTotalProductPrice() {
    if (this.selectedService.length) {
      this.sum = 0;
      this.total = 0;
      this.vatValue = 0;
      this.subtotal = 0;
      this.sumToatal = 0;
      this.totalPayAmount = 0;
      this.priceValueOfService = 0;
      
      // Calculate the base price of all services
      this.selectedService.forEach((element) => {
        element.serviceArray.forEach((ele) => {
          // Make sure we're working with numeric values
          let price = 0;
          if (ele.dealDiscount) {
            price = parseFloat(ele.dealPrice);
          } else {
            price = parseFloat(ele.price);
          }
          
          // Skip invalid prices
          if (isNaN(price)) {
            console.warn('Invalid price detected:', ele.price);
            price = 0;
          }
          
          this.priceValueOfService += price * this.quantityValue;
        });
      });
      
      // Calculate VAT amount (15% of the price)
      this.vatValue = 15 / 100;
      this.sumToatal = this.vatValue * this.priceValueOfService;
      
      // Calculate total payment amount (base price + VAT)
      this.totalPayAmount = this.sumToatal + this.priceValueOfService;
      
      // For display purposes
      this.subtotal = this.priceValueOfService;
      
      console.log('Price calculation (fixed):', {
        basePrice: this.priceValueOfService,
        vatAmount: this.sumToatal,
        totalAmount: this.totalPayAmount
      });
    } else {
      this.sum = 0;
      this.priceValueOfService = 0;
      this.sumToatal = 0;
      this.totalPayAmount = 0;
    }
  }
  timeSlots: any = '';
  duration: any;
  buyOrderData: any;
  /***
   * @bookAService
   */
  onLoadButton: boolean = false;
  bookService() {
    let url = `v2/service/buyService`;

    if (!this.duration || !this.timeSlots) {
      return this.commonService.errorToast('Please select slot');
    }

    // Extract the time from the first part of the slot
    // Slots are formatted like "9:00AM - 10:00AM" or "2:00PM - 3:00PM"
    const slotParts = this.timeSlots.split(' - ');
    if (!slotParts || slotParts.length === 0) {
      return this.commonService.errorToast('Invalid time slot format');
    }
    
    const firstInterval = slotParts[0].trim();
    const timeMatch = firstInterval.match(/(\d+):(\d+)(AM|PM)/i);
    if (!timeMatch) {
      return this.commonService.errorToast('Invalid time slot format');
    }

    let hour = parseInt(timeMatch[1]);
    const minute = parseInt(timeMatch[2]);
    const period = timeMatch[3].toUpperCase();
    
    // Convert to 24-hour format
    if (period === 'PM' && hour < 12) {
      hour += 12;
    } else if (period === 'AM' && hour === 12) {
      hour = 0;
    }
    
    // Format hour and minute with leading zeros if needed
    const formattedHour = hour < 10 ? `0${hour}` : `${hour}`;
    const formattedMinute = minute < 10 ? `0${minute}` : `${minute}`;
    
    // Get date parts from the selected date (IMPORTANT: create a new date to avoid time zone issues)
    const selectedDate = new Date(this.duration);
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
    const day = String(selectedDate.getDate()).padStart(2, '0');
    
    // Create ISO string date with the slot's time (HH:MM:00)
    // This ensures we're not using the current time
    const dateTimeString = `${year}-${month}-${day}T${formattedHour}:${formattedMinute}:00`;
    
    // Convert back to a Date object for the API
    const dateWithSlotTime = new Date(dateTimeString);
    
    console.log('Original duration:', this.duration);
    console.log('Selected slot:', this.timeSlots);
    console.log('First interval:', firstInterval);
    console.log('Extracted hour:', hour, 'minute:', minute, 'period:', period);
    console.log('Formatted date-time string:', dateTimeString);
    console.log('Final date with slot time:', dateWithSlotTime);

    let details = [];
    for (let item of this.selectedService) {
      for (let items of item.serviceArray) {
        let price = parseFloat(items.price);
        
        // Skip invalid prices
        if (isNaN(price)) {
          console.warn('Invalid price detected:', items.price);
          price = 0;
        }
        
        let obj = {
          serviceId: items._id,
          quantity: items.quantity,
          price: price,
        };
        details.push(obj);
      }
    }
    
    // Use the actual calculated values but ensure they're positive using Math.abs()
    const orderPrice = Math.abs(this.totalPayAmount);
    const actualPrice = Math.abs(this.priceValueOfService);
    const taxPrice = Math.abs(this.sumToatal);
    
    console.log('Booking service with values (absolute values):', {
      orderPrice,
      actualPrice,
      taxPrice,
      originalTotalPayAmount: this.totalPayAmount
    });
    
    let apiReqData = {
      serviceDetails: details,
      orderPrice: orderPrice,
      actualPrice: actualPrice,
      taxPrice: taxPrice,
      duration: dateWithSlotTime,
      slots: this.timeSlots,
      address: this.addressId,
    };
    
    console.log('API request data - duration:', apiReqData.duration);
    
    this.onLoadButton = true;
    this.commonService.postApi(url, apiReqData, 1).subscribe(
      (res) => {
        if (res['responseCode'] == 200) {
          this.onLoadButton = false;
          // this.profileData = res["result"];
          this.buyOrderData = res['result'];
          localStorage.setItem('paymentList', 'booking');
          this.ozhoPayment();
        } else {
          this.onLoadButton = false;
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.onLoadButton = false;
        this.commonService.errorToast(err['responseMessage']);
      }
    );
  }
  OzhoUrl: any;
  ozhoPayment() {
    let url = `order/ozowCheckOut?orderId=${this.buyOrderData._id}`;
    let data = {
      webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
      webError: this.commonService.webSiteUrl + 'customer-payment-error',
      webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
      testMode: false,
      trxFrom: 'WEB',
    };
    this.commonService.showSpinner();
    this.commonService.postApi(url, data, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.OzhoUrl = res.result;
          this.ozhoRedirect();
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }
  ozhoRedirect() {
    window.location.href = this.OzhoUrl;
  }
  listAddressData: any = [];
  listAddress() {
    let apiReqUrl = `user/listAddress`;
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.listAddressData = res.result.docs;
        this.commonService.hideSpinner();
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }
  addId: any;
  isPrimary: any;
  addressModals(id, prmy) {
    this.addId = id;
    this.isPrimary = prmy;
    $('#addressModal').modal('show');
  }

  deleteAddress() {
    let apiReqUrl = `user/deleteAddress?addressId=${this.addId}`;
    if (this.isPrimary == true) {
      return this.commonService.errorToast(
        'You can not delete primary address'
      );
    } else {
      this.commonService.showSpinner();
      this.commonService.deleteApi(apiReqUrl, 1).subscribe((res: any) => {
        if (res.responseCode == 200) {
          // this.listAddressData = res.result.docs;
          $('#addressModal').modal('hide');
          this.listAddress();
          this.commonService.hideSpinner();
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage);
        }
      });
    }
  }
  openListAddress() {
    $('#listAddressModal').modal('show');
  }
  toAddressId(id) {
    localStorage.setItem('primaryAddressId', id);
    $('#listAddressModal').modal('hide');
  }
  quantityValue: any = 1;
  updateCartValue(actionType?) {
    this.duration = '';
    actionType == 'ADD' ? ++this.quantityValue : --this.quantityValue;
    if (this.quantityValue == 0) {
      this.commonService.infoToast('Product quantity can not be 0.');
      return;
    }
    this.getTotalProductPrice();
  }
  navigateToback() {
    this.router.navigate(['/customer-service-available-add'], {
      queryParams: {
        categoryId: this.catID,
        userId: this.UsID,
        categoryName: this.categoryName,
      },
    });
  }
  slotData: any;
  getQuantity(date) {
    let url = `service/makeSlots`;
    let quantity = 0;
    for (let item of this.selectedService) {
      for (let items of item.serviceArray) {
        quantity = items.quantity + quantity;
      }
    }
    let startDate = '';
    let currentDate = new Date().toISOString().split('T')[0];
    let incommingDate = new Date(date).toISOString().split('T')[0];
    if (currentDate === incommingDate) {
      startDate = `${new Date().getHours()}:${new Date().getMinutes()}`;
    } else {
      startDate = '09:00';
    }
    let data = {
      userId: this.UsID,
      quantity: quantity,
      date: new Date(date).toLocaleDateString(),
      startDate: startDate,
    };
    this.commonService.postApi(url, data, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.slotData = res.result.docs;
        this.commonService.hideSpinner();
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }
  isLoaded: boolean = false;

  onLoadImage() {
    this.isLoaded = true;
  }

  isDiscount(data): boolean {
    if (data.dealPrice != data.price) {
      return true;
    }
    return false;
  }

  serviceList = [];
  openModal() {
    $('#intrestedPriceModal').modal('show');
    this.serviceList = JSON.parse(sessionStorage.getItem('selectedService'));
  }
  _categoryId;
  _serviceId;
  subServiceList: any = [];
  // spordicType: string = 'AUTOMATIC';
  servicePrice;
  _discountedPrice;
  startCampaign() {
    if (this._discountedPrice === '0') {
      this.commonService.errorToast('Interested Price cannot be 0 ');
      return;
    }
    let data = {
      serviceId: this._serviceId,
      price: `${this.servicePrice}`,
      interestedPrice: `${this._discountedPrice}`,
      spordicType: this.spordicType,
    };
    console.log(data);
    let url = `campaign/addIntrestPriceOnService`;

    this.commonService.postApi(url, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        $('#intrestedPriceModal').modal('hide');
        this.commonService.hideSpinner();
        this.toastrService.success('Intrested price added successfully');
        // this.commonService.successToast(res.responseMessage)
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }
  getSubCatList(e) {
    let find = this.serviceList.find((ele) => {
      return ele.subCategory.categoryId._id == e;
    });
    this.subServiceList = find.serviceArray;
    console.log(this.subServiceList);
  }
  getPriceService(e) {
    console.log(e);

    let find = this.subServiceList.find((ele) => {
      return ele._id == e;
    });
    this.servicePrice = find.price;
  }
  getDiscount(price, discountPrice) {
    let temp = Number(price) - Number(discountPrice);
    let percent = (temp / Number(price)) * 100;
    return percent.toFixed(2);
  }

  yocoPayment() {
    console.log('Starting Yoco payment process');
    console.log('Order ID:', this.buyOrderData._id);
    
    // Additional logging to check payment amount
    if (this.buyOrderData && this.buyOrderData.orderPrice) {
      console.log('Order Price before Yoco payment:', this.buyOrderData.orderPrice);
      // Ensure the price is positive
      if (this.buyOrderData.orderPrice < 0) {
        console.warn('Negative order price detected, converting to positive value');
        this.buyOrderData.orderPrice = Math.abs(this.buyOrderData.orderPrice);
      }
    }
    
    this.flag = false; // Disable buttons during processing
    
    // Store payment method and order ID in localStorage so success page knows which order to update
    localStorage.setItem('paymentMethod', 'YOCO');
    localStorage.setItem('lastOrderId', this.buyOrderData._id);
    localStorage.setItem('orderTimestamp', new Date().toISOString());
    localStorage.setItem('from_yoco_payment', 'true');
    
    // We need to make a request to our backend API which will then create a checkout with Yoco
    // and return the redirect URL
    
    let url = `payment/checkoutYoco?orderId=${this.buyOrderData._id}`;
    let data = {
      webFailure: `${window.location.origin}/customer-payment-cancel`,
      webError: `${window.location.origin}/customer-payment-error`,
      webSuccess: `${window.location.origin}/customer-payment-success?orderId=${this.buyOrderData._id}`,
      cancelUrl: `${window.location.origin}/customer-payment-cancel`,
      errorUrl: `${window.location.origin}/customer-payment-error`,
      successUrl: `${window.location.origin}/customer-payment-success?orderId=${this.buyOrderData._id}`,
      testMode: true,
      trxFrom: 'WEB'
    };
    
    console.log('Sending request to backend:', this.commonService.baseUrl + url);
    console.log('With data:', JSON.stringify(data));
    this.commonService.showSpinner();
    
    // Call our backend API to create the Yoco checkout
    this.commonService.postApi(url, data, 1).subscribe(
      (res: any) => {
        console.log('Received response from backend:', JSON.stringify(res));
        if (res['responseCode'] == 200 || res['responseCode'] == 'SUCCESS') {
          this.commonService.hideSpinner();
          
          // Check if the response contains a redirect URL or HTML form
          if (res.result && res.result.checkoutUrl) {
            // If we have a direct redirect URL, use it
            console.log('Redirecting to Yoco checkout URL:', res.result.checkoutUrl);
            window.location.href = res.result.checkoutUrl;
            return;
          } else if (res.result && res.result.file) {
            // If we have an HTML form, render it in the DOM
            console.log('Rendering HTML form from response');
            try {
              // Create a container for the form
              const formContainer = document.createElement('div');
              formContainer.innerHTML = res.result.file;
              document.body.appendChild(formContainer);
              
              // Find and submit the form
              setTimeout(() => {
                const form = document.getElementById('yoco-form');
                if (form) {
                  console.log('Submitting Yoco form');
                  (form as HTMLFormElement).submit();
                } else {
                  console.error('Yoco form not found in response');
                  this.commonService.errorToast('Error processing payment. Please try again.');
                  this.flag = true; // Re-enable buttons
                }
              }, 500);
            } catch (error) {
              console.error('Error rendering HTML form:', error);
              this.commonService.errorToast('Error processing payment. Please try again.');
              this.flag = true; // Re-enable buttons
            }
          } else {
            console.error('Invalid response format from Yoco checkout API:', JSON.stringify(res.result));
            this.commonService.errorToast('Error processing payment. Please try again.');
            this.flag = true; // Re-enable buttons
          }
        } else {
          this.commonService.hideSpinner();
          console.error('Error response from backend:', JSON.stringify(res));
          this.commonService.errorToast(res['responseMessage'] || 'Error processing payment');
          this.flag = true; // Re-enable buttons
        }
      },
      (err) => {
        console.error('Yoco checkout error:', err);
        if (err.error && err.error.responseMessage) {
          console.error('Error details:', err.error.responseMessage);
        }
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error while processing payment. Please check the console for details.');
        this.flag = true; // Re-enable buttons
      }
    );
  }
}
